import Alpine from "alpinejs";

/**
 * This sets up the Alpine data store for managing notification bar states
 */
Alpine.store('notification_covid19', {
    init() {
        // @todo: may be unnecessary, but limiting it to 14 days for now
        const limitDismissDays = 14;
        const notificationDismissed = parseInt(localStorage.getItem('notification_covid19'))
        if (!isNaN(notificationDismissed)) {
            const secondsSinceDismissed = (Date.now().valueOf() / 1000) - notificationDismissed;
            const limitDismissSeconds = limitDismissDays * 24 * 60 * 60;
            if (limitDismissSeconds > secondsSinceDismissed) {
                this.state.dismissed = true;
            }
        }
    },

    state: {
        // Show the content of the notification modal
        showModal: false,
        // Notification has been dismissed
        dismissed: false,
    },

    dismiss() {
        this.state.dismissed = true;
        this.state.showModal = false;
        localStorage.setItem('notification_covid19', Math.floor(Date.now().valueOf() / 1000).toString());
    },

    hideModal() {
        this.state.showModal = false;
    },

    showModal() {
        this.state.showModal = true;
    },

});
